/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["toolbar-actions{display:-webkit-box;display:flex;-webkit-box-align:center;align-items:center;color:#656565}toolbar-actions context-actions-container{border-right:1px solid #e0e0e0;padding-right:5px;margin-right:5px}toolbar-actions .always-visible-actions .active{color:#1565c0}"];
export { styles as styles };
